import script from "./OnboardingStep2.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingStep2.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingStep2.vue?vue&type=style&index=0&id=58968a7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58968a7f"]])

export default __exports__